// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "trix";
import "@rails/actiontext";
import * as ActiveStorage from "@rails/activestorage";
import "chartkick/chart.js";
import "@khmyznikov/pwa-install";

ActiveStorage.start();

import "./helpers/leaflet_setup";
import "./controllers";
import "./service-worker-companion";
import "./onlineStatus";
import { initIndexDB } from "./db";
import { Chart } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
// Import cleanup manager to enable automatic file cleanup
import "./db/cleanupManager";
// Import cleanup utilities for debugging
import "./db/cleanupUtils";

initIndexDB();
Chart.register(annotationPlugin);

// Re-evaluate Chartkick inline scripts after Turbo visits that did not
// execute them (morph page refreshes). Skip the initial page load and skip
// charts that already have a connected canvas so Drive visits do not replace
// the live Chart.js instance Stimulus has already bound to.
let turboInitialLoadComplete = false;
document.addEventListener("turbo:load", () => {
  if (!turboInitialLoadComplete) {
    turboInitialLoadComplete = true;
    return;
  }
  document.querySelectorAll("script").forEach((script) => {
    if (!script.textContent.includes("createChart")) return;

    const chartId = script.textContent.match(/new Chartkick\[[^\]]+\]\("([^"]+)"/)?.[1];
    const canvas = window.Chartkick?.charts?.[chartId]?.chart?.canvas;
    if (canvas?.isConnected) return;

    const newScript = document.createElement("script");
    newScript.textContent = script.textContent;
    script.replaceWith(newScript);
  });
});
